// extracted by mini-css-extract-plugin
module.exports = {"clear":"clear-2clgjBj-","clearfix":"clearfix-W6uu0tN_"};